import { authHeaders } from "utils";

/**
 * Fetches doc with needed authHeaders for universalLogin, working around
 * current proxy limitations. Once we complete retireProxy work these document
 * links can probably return to being regular anchor tags.
 *
 * This works by fetching the file, transforming it into a url, and opening it
 * in a new tab.
 *
 * @param url
 */
export async function openDocument(url: string) {
  const res = await fetch(url, {
    headers: authHeaders(),
  });
  if (res.ok) {
    const doc = await res.blob();
    const objUrl = URL.createObjectURL(doc);
    const newWin = window.open(objUrl, "_blank");

    if (!newWin || newWin.closed || typeof newWin.closed == "undefined") {
      //POPUP BLOCKED - try to open in the same tab
      const aTag = document.createElement("a");
      aTag.setAttribute("href", objUrl);
      aTag.click();
    } else {
      newWin.focus();
    }
  } else {
    console.error(`fetching doc err: ${url}`);
  }
}
